<template>
    <div class="row">
        <div class="col-lg-12">
            <div class="panel panel-primary m-t-md">
                <div class="panel-heading">
                    <div class="row">
                        <div class="col-md-6">
                            <h4>
                                {{ (order.customerAddressesByCustomerAddressId) ? order.customerAddressesByCustomerAddressId.customersByCustomerId.name : order.dvmAddress.dvmCustomer.name }}
                            </h4>
                        </div>
                        <div class="col-md-6 text-right">
                            <label>Order Id: </label> {{ order.id }}
                        </div>
                    </div>
                </div>
                <div class="panel-body" :class="{'bg-danger': (order.statusesByStatusId.id===1 || order.statusesByStatusId.id===9)}">
                    <div class="row">
                        <div class="col-lg-6">
                            <label>Source: </label> {{ (order.orderSource)? order.orderSource.source : "N/A"  }}
                            <br><label>Payment Method: </label> {{ (order.paymentMethod ? order.paymentMethod.name : "N/A") }}
                            <br><label>Amount: </label> {{ order.totalPriceAfterTax }}
                            <br><label>Status:&nbsp;&nbsp;&nbsp;&nbsp;</label><span
                            :class="'label ' + order.statusesByStatusId.cssClass">{{
                                order.statusesByStatusId.name
                            }} </span>
                        </div>
                        <div class="col-lg-6 text-right">
                            <label>Date-Time: </label> {{ order.created | formatDate }}
                            <br><label>Payment Status: </label> {{ (order.paymentStatus) ? order.paymentStatus.name : "N/A" }}
                            <br><label>Order type: </label> {{ order.orderTypesByOrderTypeId.type }}
                            <br><a @click="viewOrder" class="btn btn-primary view_btn" href="javascript:void(0)">View</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "OrderRow",
    props: {
        order: {
            type: Object,
            required: true
        }
    },
    methods: {
        viewOrder() {
            this.$emit('viewOrder', this.order.id)
        }
    }
}
</script>

<style scoped>

</style>
